import { create } from 'zustand';
import { type IShapeExtension } from '@meitu/saas-editor-core/es/version-types';

/**
 * Q: 为什么需要存储 shapeExtensionCache？
 * A: 因为进入编辑态时，若图层有使用变形文字效果，会临时将变形效果取消，
 *    此时图层的 shapeExtension 会变为 null，此时会影响到业务中的判断，
 *    因此需要存储 shapeExtensionCache
 */

type State = {
    shapeExtensionCache: IShapeExtension | null;
};

type Actions = {
    setShapeExtensionCache: (shapeExtension: IShapeExtension | null) => void;
};

type Store = State & Actions;

const initialState: State = {
    shapeExtensionCache: null,
};

export const useStore = create<Store>((set) => ({
    ...initialState,
    setShapeExtensionCache: (shapeExtension) => set({ shapeExtensionCache: shapeExtension }),
}));
